export const EVENT_TRANSACTION_FEE_CREATE = 'transactionFee.create'
export const EVENT_FEE_DISABLE = 'fee.disable'
